<template>
	<c-dialog ref="dialog" title="请选择产品型号" height="70vh" :close-button="closeButton" enable-flex button-name="下一步" @resolve="resolveHandle">
		<c-scroll class="category" scroll-x>
			<ul class="flex-start-center">
				<li v-for="(item, i) in categoryList" :key="i" :class="{'z-crt': currentCategory == item.value}" @click="currentCategory = item.value">{{item.name}}</li>
			</ul>
		</c-scroll>
		<div class="flex-grow flex">
			<c-scroll v-show="brandList.length" class="brand">
				<ul>
					<li v-for="(item, i) in brandList" :key="i" class="ellipsis-2" :class="{'z-crt': currentBrand == item.value}" @click="currentBrand = item.value">{{item.name}}</li>
				</ul>
			</c-scroll>
			<c-scroll class="model flex-grow">
				<ul class="flex-wrap">
					<li v-for="(item, i) in modelList" :key="i" class="flex-center" :class="{'z-crt': currentModel == item.value}" @click="currentModel = item.value">
						<p class="ellipsis-2">{{item.name}}</p>
					</li>
				</ul>
				<c-empty v-if="!modelList.length"></c-empty>
			</c-scroll>
		</div>
	</c-dialog>
</template>

<script>
	export default {
		props: {
			closeButton: Boolean
		},

		data() {
			return {
				categoryList: [],
				currentCategory: '',

				brandList: [],
				currentBrand: '',

				modelList: [],
				currentModel: ''
			}
		},

		computed: {
			allSelected() {
				return this.channelList.length && !!(this.currentChannel.length == (this.channelList[0].length + this.channelList[1].length));
			}
		},

		watch: {
			currentCategory(val) {
				val && this.updateBrand();
			},

			currentBrand(val) {
				val && this.updateModel();
			}
		},
		
		methods: {
			open() {
				this.$refs.dialog.open();
				this.updateCategory();
			},

			updateCategory() {
				this.request({
					url: '/spu/category/options',
					success: data => {
						this.categoryList = data;
						this.currentCategory = data[0].value;
					}
				});
			},

			updateBrand() {
				this.brandList = [];
				this.modelList = [];
				this.request({
					url: '/spu/brand/options',
					data: {
						category_id: this.currentCategory
					},
					success: data => {
						this.brandList = data;
						if (data.length) {
							if (this.currentBrand == data[0].value) {
								this.updateModel();
							} else {
								this.currentBrand = data[0].value;
							}
						} else {
							this.currentBrand = '';
							this.currentModel = '';
						}
					}
				});
			},

			updateModel() {
				this.modelList = [];
				this.request({
					url: '/spu/model/options',
					data: {
						category_id: this.currentCategory,
						brand_id: this.currentBrand
					},
					success: data => {
						this.modelList = data;
					}
				});
			},

			resolveHandle(stop) {
				if (!this.currentModel) {
					this.$message({
						message: '请选择产品型号'
					});
					stop();
					return;
				}

				this.$emit('resolve', {
					category: this.categoryList.find(item => item.value == this.currentCategory),
					brand: this.brandList.find(item => item.value == this.currentBrand),
					model: this.modelList.find(item => item.value == this.currentModel)
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.category {
		ul {
			gap: .14rem;
			box-sizing: border-box;
			min-width: 100%;
			height: 1.08rem;
			padding: 0 .2rem;
			background: var(--color-main);

			li {
				border-radius: .32rem;
				padding: 0 .26rem;
				line-height: .64rem;
				font-size: .3rem;
				white-space: nowrap;
				color: #fff;
				background: rgba(255,255,255,.2);

				&.z-crt {
					font-weight: 600;
					color: var(--color-main);
					background: #fff;
				}
			}
		}
	}

	.brand {
		ul {
			width: 2rem;
			padding: .16rem 0;

			li {
				padding: .2rem .1rem;
				line-height: .4rem;
				font-size: .28rem;
				text-align: center;
				color: #444;

				&.z-crt {
					font-size: .3rem;
					font-weight: 600;
					color: var(--color-main);
					background: #F5F5F5;
				}
			}
		}
	}

	.model {
		background: #F5F5F5;

		ul {
			gap: .14rem;
			padding: .14rem .22rem;

			li {
				box-sizing: border-box;
				width: 2.46rem;
				height: .8rem;
				padding: 0 .1rem;
				line-height: .32rem;
				font-size: .26rem;
				text-align: center;
				background: #fff;

				&.z-crt {
					font-weight: 600;
					color: var(--color-main);
				}
			}
		}
	}
</style>